import { render, staticRenderFns } from "./UserRoleSelect.vue?vue&type=template&id=64abd8d1&scoped=true"
import script from "./UserRoleSelect.vue?vue&type=script&lang=js"
export * from "./UserRoleSelect.vue?vue&type=script&lang=js"
import style0 from "./UserRoleSelect.vue?vue&type=style&index=0&id=64abd8d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64abd8d1",
  null
  
)

export default component.exports